export default "__VITE_ASSET__de9e580c__"